var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.DefaultLayer = new Class({
    Extends: OCS.Viewer.Classes.VectorLayer,
    debug: false,
    class_name: "DefaultLayer",
    source: null,
    options: {
        style_type: 'point'
    },
    create: function () {
        var ops = {style: this.get_style_manager().get_layer_style_method()};
        var vector_layer = new ol.layer.Vector(ops);
        this.set_layer(vector_layer);
        if (this.debug) {
            console.log("Shape file layer created.");
        }

        return vector_layer;
    },
    create_geoJSON_source: function (options) {
        var source = new ol.source.Vector({
            features_ready: false,
            format: new ol.format.GeoJSON()
        });
        source.once('change', function (event) {
            source.forEachFeature(this.set_feature_id, this);
            if (options.ready_callback) {
                options.ready_callback();
            }
        }, this);
        return source;
    },
    set_feature_id: function (feature) {
        var id = feature.getId();
        if (!id && feature.get('ID')) {
            id = feature.get('ID');
            feature.setId(id);
        }
        if(OCS.Viewer.Config.watched_county_objs[id]) {
            var county_obj = OCS.Viewer.Config.watched_county_objs[id];
            feature.set('CID', county_obj.CID);
            feature.set('ZID', county_obj.ID);
            feature.set('NAME', county_obj.NAME);
        }
        
        //feature.set('style', true);
    },
    get_radar_range_feature_style: function () {
        return this.get_style_manager().get_radar_range_style();
    },
    set_source: function (source) {
        if (!this.get_ol_object()) {
            // The layer doesn't exist so create it.
            this.create();
        }
        this.source = source;
        this.get_ol_object().setSource(source);
    },
    get_source: function () {
        return this.source;
    },

    create_point_source: function (options) {
        var source = this.create_vector_source(options);

        // Get the site information and store it as points

        if (options && options.url) {
            var points = [];
            $.getJSON(options.url, function (data) {
                Object.each(data, function (site, key) {
                    if (!site.name.match(/retired/)) {
                        //var point = new ol.geom.Point(ol.proj.transform([Number(site.lon), Number(site.lat)], this.options.display_projection, this.options.projection));
                        var point = new ol.geom.Circle(ol.proj.transform([Number(site.lon), Number(site.lat)], this.options.display_projection, this.options.projection), 5000);
                        var pointFeature = new ol.Feature(point);
                        pointFeature.set('NAME', site.name);
                        pointFeature.set('STNM', site.stnm);
                        pointFeature.set('ID', key);
                        pointFeature.setId(key);
                        points.push(pointFeature);
                    }
                }.bind(this));
                source.addFeatures(points);
            }.bind(this));

            source.once('change', function (event) {
                source.forEachFeature(this.set_feature_id, this);
                if (options.ready_callback) {
                    options.ready_callback();
                }
            }, this);
        }
        return source;
    },
    create_vector_source: function (options) {
        var source;
        if (options && options.features) {
            source = new ol.source.Vector({
                features: options.features,
                projection: this.options.projection
            });
        } else {
            source = new ol.source.Vector({
                projection: this.options.projection
            });
        }
        return source;
    },

});

